import React from "react";
import { Component } from "react";
import JobsList from "./components/JobsList";
import RaiseTicketPopup from "views/profile/components/my-offers/components/RaiseTicketPopup";
class MyOffers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      israisedticketopen: false,
    };
  }
  render() {
    return (
      <div className="">
        <RaiseTicketPopup
          showTicket={this.state.israisedticketopen}
          onclose={() => this.setState({ israisedticketopen: false })}
        />
        <div className="lg:text-right md:text-right text-center mb-6 lg:mt-0 md:mt-0 mt-6">
          <button
            className="outline-button w-230px h-50px fsize16 font-semibold rounded-25px"
            onClick={() => this.setState({ israisedticketopen: true })}
          >
            RAISE A TICKET
          </button>
        </div>

        <div>
          <JobsList />
        </div>
      </div>
    );
  }
}
export default MyOffers;
